'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadCoreModules = undefined;

var _ = require('../');

var _modal = require('../../components/modal/modal');

var _initModules = require('./initModules');

var loadCoreModules = exports.loadCoreModules = function loadCoreModules() {
  var coreModules = [
  /**
   * Main Navigation Modules
   */
  {
    name: 'header-search',
    init: _.headerSearch
  }, {
    name: 'banner-search',
    init: _.bannerSearch
  }, {
    name: 'header',
    init: _.header
  }, {
    name: 'drawers',
    init: _.drawers
  }, {
    name: 'push-cart',
    init: _.pushCart
  }, {
    name: 'navigation-overlay',
    init: _.navigationOverlay
  }, {
    name: 'announcement-bar-carousel',
    init: _.announcementBarCarousel
  }, {
    name: 'mobile-nav',
    init: _.mobileNav
  },

  /**
   * Footer Modules
   */
  {
    name: 'footer-accordion',
    init: _.footerAccordion
  },

  /**
   * Sections
   */
  {
    name: 'accordion',
    init: _.accordion
  }, {
    name: 'collection-grid-sidebar',
    init: _.collectionGridSidebar
  }, {
    name: 'collection-grid',
    init: _.collectionGrid
  }, {
    name: 'countdown',
    init: _.countdown
  }, {
    name: 'offgrid-carousel',
    init: _.offgridCarousel
  },

  /**
   * Misc Modules
   */
  {
    name: 'carousel',
    init: _.carousel
  }, {
    name: 'copy-to-clipboard',
    init: _.copyToClipboard
  }, {
    name: 'form-field',
    init: _.formField
  }, {
    name: 'ga-tracking',
    init: _.gaTracking
  }, {
    name: 'load-more',
    init: _.loadMore
  }, {
    name: 'modal-info',
    init: _.modalInfo
  }, {
    name: 'modal',
    init: _modal.init
  }, {
    name: 'brands-welcome-modal',
    init: _.brandsWelcomeModal
  }, {
    name: 'newsletter-modal',
    init: _.newsletterModal
  }, {
    name: 'newsletter-subscription',
    init: _.newsletterSubscription
  }, {
    name: 'parallax',
    init: _.parallax
  }, {
    name: 'scroll-to',
    init: _.scrollTo
  }, {
    name: 'scroll-visibility',
    init: _.scrollVisibility
  }, {
    name: 'theme-toggle',
    init: _.themeToggle
  }, {
    name: 'wishlist-button',
    init: _.wishlistButton
  }, {
    name: 'backinstock-button',
    init: _.backinstockButton
  }, {
    name: 'zendesk-widget',
    init: _.zendeskWidget
  }];

  (0, _initModules.initModules)(coreModules);
};